export default {
      id: "i-accounting-usage",
      viewBox: "0 0 59 59",
      url: __webpack_public_path__ + "img/sprite.svg#i-accounting",
      toString: function () {
        return this.url;
      }
    }